
export const TiposAtestados = {
  Comparecimento: 112509,
  Internacao: 118688,
  CadeiraRodas: 112511,
  Acessibilidade: 112512,
  Fraldas: 112513,
  Declaracao: 113448
}

export const TiposDocumentos = {
  Atestado: 2,
  Relatorio: 4,
  CopiaProntuario: 7
}

export const PasseLivreInterestadual = 100010
